import api from '../../services/api';

export const getFinancialOverview = async () => {
    try {
        const response = await api.get('/admin/financial/overview');
        return response.data;
    } catch (error) {
        console.error('Error fetching financial overview:', error);
        throw error;
    }
};

export const getWallets = async () => {
    try {
        const response = await api.get('/admin/financial/wallets');
        return response.data;
    } catch (error) {
        console.error('Error fetching wallets:', error);
        throw error;
    }
};

export const getWithdrawals = async (status = '') => {
    try {
        const response = await api.get(`/admin/financial/withdrawals${status ? `?status=${status}` : ''}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching withdrawals:', error);
        throw error;
    }
};

export const approveWithdrawal = async (id) => {
    try {
        const response = await api.post(`/admin/financial/withdrawals/${id}/approve`);
        return response.data;
    } catch (error) {
        console.error('Error approving withdrawal:', error);
        throw error;
    }
};

export const rejectWithdrawal = async (id, reason) => {
    try {
        const response = await api.post(`/admin/financial/withdrawals/${id}/reject`, { reason });
        return response.data;
    } catch (error) {
        console.error('Error rejecting withdrawal:', error);
        throw error;
    }
};

export const getFinancialSettings = async () => {
    try {
        const response = await api.get('/admin/financial/settings');
        return response.data;
    } catch (error) {
        console.error('Error fetching financial settings:', error);
        throw error;
    }
};

export const updateFinancialSetting = async (key, value, description) => {
    try {
        const response = await api.post('/admin/financial/settings', { key, value, description });
        return response.data;
    } catch (error) {
        console.error('Error updating financial setting:', error);
        throw error;
    }
};

export const adjustEscrow = async (wallet_id, amount, type, reason) => {
    try {
        const response = await api.post('/admin/financial/adjust-escrow', { wallet_id, amount, type, reason });
        return response.data;
    } catch (error) {
        console.error('Error adjusting escrow:', error);
        throw error;
    }
};

// --- ADMIN LOANS ---

export const getAdminLoans = async (status = '') => {
    try {
        const response = await api.get(`/admin/financial/loans${status ? `?status=${status}` : ''}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching admin loans:', error);
        throw error;
    }
};

export const updateAdminLoanStatus = async (id, status) => {
    try {
        const response = await api.put(`/admin/financial/loans/${id}/status`, { status });
        return response.data;
    } catch (error) {
        console.error('Error updating loan status:', error);
        throw error;
    }
};

// --- SAVINGS CHALLENGES ADMIN ---

export const getAdminSavingsChallenges = async () => {
    try {
        const response = await api.get('/admin/savings-challenges');
        return response.data;
    } catch (error) {
        console.error('Error fetching admin challenges:', error);
        throw error;
    }
};

export const createAdminSavingsChallenge = async (data) => {
    try {
        const response = await api.post('/admin/savings-challenges', data);
        return response.data;
    } catch (error) {
        console.error('Error creating challenge:', error);
        throw error;
    }
};

export const updateAdminSavingsChallenge = async (id, data) => {
    try {
        const response = await api.put(`/admin/savings-challenges/${id}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating challenge:', error);
        throw error;
    }
};

export const cancelAdminSavingsChallenge = async (id) => {
    try {
        const response = await api.delete(`/admin/savings-challenges/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error cancelling challenge:', error);
        throw error;
    }
};

export const getChallengeSavingsParticipants = async (id) => {
    try {
        const response = await api.get(`/admin/savings-challenges/${id}/participants`);
        return response.data;
    } catch (error) {
        console.error('Error fetching participants:', error);
        throw error;
    }
};

// --- NEW AUDIT & ANALYTICS ---

export const getAuditLogs = async (params = {}) => {
    try {
        const urlParams = new URLSearchParams(params).toString();
        const response = await api.get(`/admin/finance/audit-log${urlParams ? `?${urlParams}` : ''}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching audit logs:', error);
        throw error;
    }
};

export const getFlaggedAuditLogs = async () => {
    try {
        const response = await api.get('/admin/finance/audit-log/flagged');
        return response.data;
    } catch (error) {
        console.error('Error fetching flagged audit logs:', error);
        throw error;
    }
};

export const resolveAuditFlag = async (id, notes) => {
    try {
        const response = await api.put(`/admin/finance/audit-log/${id}/resolve`, { notes });
        return response.data;
    } catch (error) {
        console.error('Error resolving audit flag:', error);
        throw error;
    }
};

export const manualWalletAdjust = async (userId, amount, type, reason) => {
    try {
        const response = await api.post(`/admin/finance/users/${userId}/wallet/adjust`, { amount, type, reason });
        return response.data;
    } catch (error) {
        console.error('Error with manual wallet adjust:', error);
        throw error;
    }
};


export default {
    getFinancialOverview,
    getWallets,
    getWithdrawals,
    approveWithdrawal,
    rejectWithdrawal,
    getFinancialSettings,
    updateFinancialSetting,
    adjustEscrow,
    getAdminLoans,
    updateAdminLoanStatus,
    getAdminSavingsChallenges,
    createAdminSavingsChallenge,
    updateAdminSavingsChallenge,
    cancelAdminSavingsChallenge,
    getChallengeSavingsParticipants,
    getAuditLogs,
    getFlaggedAuditLogs,
    resolveAuditFlag,
    manualWalletAdjust
};

